import Marquee from "react-fast-marquee";
import "./style.scss";
import { isMobile } from "react-device-detect";

const imagesLaunchpadTop = Array.from({ length: 7 }, (_, index) => `/images/new/apply/${index + 1}.svg`);
const imagesLaunchpadBottom = Array.from({ length: 7 }, (_, index) => `/images/new/apply/${index + 5}.svg`);
const imagesCapitalTop = Array.from({ length: 3 }, (_, index) => `/images/new/apply/${index + 12}.svg`);
const imagesCapitalBottom = Array.from({ length: 3 }, (_, index) => `/images/new/apply/${index + 17}.svg`);
const imagesExchanges = Array.from({ length: 3 }, (_, index) => `/images/new/apply/${index + 20}.svg`);
const imagesExchangesBottom = Array.from({ length: 3 }, (_, index) => `/images/new/apply/${index + 23}.svg`);
const imagesMedia = Array.from({ length: 3 }, (_, index) => `/images/new/apply/${index + 26}.svg`);
const imagesSecurity = Array.from({ length: 3 }, (_, index) => `/images/new/apply/${index + 29}.svg`);
const Partners = () => {
  return (
    <>
      <div className="partners">
        <div className="part-title">Ecosystem Partners</div>
        <div className="part-des">
          We’re supported by{" "}
          <span style={{ color: "#faad14", fontWeight: "600" }}>120+</span>{" "}
          partners in our ecosystem
        </div>
        <div className="launchpad-container">
          <div className="launchpad-marquee-container">
            <div className="flex">
              <p className="new-title">Launchpad</p><p className="new-value">20+</p>
            </div>
            <Marquee
              className="custom-marquee-partner"
              direction="right"
              gradient={!isMobile}
              pauseOnHover
              speed={20}
              loop={0}
              autoFill
              gradientWidth={150}
              gradientColor={'#F8F9FB'}
            >
              {imagesLaunchpadTop.map((item, index) => (
                <div className="marquee-item">
                  <img
                    key={index}
                    src={item}
                    alt=''
                  />
                </div>
              ))}
            </Marquee>
            <Marquee
              className="custom-marquee-partner bottom"
              direction="left"
              gradient={!isMobile}
              pauseOnHover
              speed={20}
              loop={0}
              autoFill
              gradientWidth={150}
              gradientColor={'#F8F9FB'}
            >
              {imagesLaunchpadBottom.map((item, index) => (
                <div className="marquee-item">
                  <img
                    key={index}
                    src={item}
                    alt=''
                  />
                </div>
              ))}
            </Marquee>
          </div>
          <div className="launchpad-row">
            <div className="launchpad-marquee-container new-item">
              <div className="flex">
                <p className="new-title">Capital Venture</p><p className="new-value">12+</p>
              </div>
              <Marquee
                className="custom-marquee-partner"
                direction="right"
                gradient={!isMobile}
                pauseOnHover
                speed={20}
                loop={0}
                autoFill
                gradientWidth={150}
                gradientColor={'#F8F9FB'}
              >
                {imagesCapitalTop.map((item, index) => (
                  <div className="marquee-item">
                    <img
                      key={index}
                      src={item}
                      alt=''
                    />
                  </div>
                ))}
              </Marquee>
              <Marquee
                className="custom-marquee-partner bottom"
                direction="left"
                gradient={!isMobile}
                pauseOnHover
                speed={20}
                loop={0}
                autoFill
                gradientWidth={150}
                gradientColor={'#F8F9FB'}
              >
                {imagesCapitalBottom.map((item, index) => (
                  <div className="marquee-item">
                    <img
                      key={index}
                      src={item}
                      alt=''
                    />
                  </div>
                ))}
              </Marquee>
            </div>
            <div className="launchpad-marquee-container new-item">
              <div className="flex">
                <p className="new-title">EXCHANGE</p><p className="new-value">12+</p>
              </div>
              <Marquee
                className="custom-marquee-partner"
                direction="right"
                gradient={!isMobile}
                pauseOnHover
                speed={20}
                loop={0}
                autoFill
                gradientWidth={150}
                gradientColor={'#F8F9FB'}
              >
                {imagesExchanges.map((item, index) => (
                  <div className="marquee-item">
                    <img
                      key={index}
                      src={item}
                      alt=''
                    />
                  </div>
                ))}
              </Marquee>
              <Marquee
                className="custom-marquee-partner bottom"
                direction="left"
                gradient={!isMobile}
                pauseOnHover
                speed={20}
                loop={0}
                autoFill
                gradientWidth={150}
                gradientColor={'#F8F9FB'}
              >
                {imagesExchangesBottom.map((item, index) => (
                  <div className="marquee-item">
                    <img
                      key={index}
                      src={item}
                      alt=''
                    />
                  </div>
                ))}
              </Marquee>
            </div>
          </div>
          <div className="launchpad-row">
            <div className="launchpad-marquee-container new-item">
              <div className="flex">
                <p className="new-title">Media</p><p className="new-value">12+</p>
              </div>
              <Marquee
                className="custom-marquee-partner"
                direction="right"
                gradient={!isMobile}
                pauseOnHover
                speed={20}
                loop={0}
                autoFill
                gradientWidth={150}
                gradientColor={'#F8F9FB'}
              >
                {imagesMedia.map((item, index) => (
                  <div className="marquee-item">
                    <img
                      key={index}
                      src={item}
                      alt=''
                    />
                  </div>
                ))}
              </Marquee>
            </div>
            <div className="launchpad-marquee-container new-item">
              <div className="flex">
                <p className="new-title">Security</p><p className="new-value">12+</p>
              </div>
              <Marquee
                className="custom-marquee-partner bottom"
                direction="left"
                gradient={!isMobile}
                pauseOnHover
                speed={20}
                loop={0}
                autoFill
                gradientWidth={150}
                gradientColor={'#F8F9FB'}
              >
                {imagesSecurity.map((item, index) => (
                  <div className="marquee-item">
                    <img
                      key={index}
                      src={item}
                      alt=''
                    />
                  </div>
                ))}
              </Marquee>
            </div>
          </div>
          {/* <div className="game-list-item">
            {listImg2.map((item: any, i: any) => (
              <div className="game-item item1">
                <img src={item} alt="" />
              </div>
            ))}
            <div className="game-item item1">
              <img
                style={{ width: "50px", height: "50px" }}
                src="./images/partners/pa-m.png"
                alt=""
              />
            </div>
            <div className="game-item item1">
              <img src="./images/partners/pa-launchzone.png" alt="" />
            </div>
          </div> */}
          {/* <div className="bscs-gamefi">Capital Venture</div>
          <div className="game-list-item">
            {listImg3.map((item: any, i: any) => (
              <div className="game-item item1">
                <img src={item} alt="" />
              </div>
            ))}
          </div> */}
          {/* <div className="game-list-item">
            {listImg4.map((item: any, i: any) => (
              <div className="game-item item1">
                <img src={item} alt="" />
              </div>
            ))}
          </div>
          <div className="game-list-item">
            {listImg5.map((item: any, i: any) => (
              <div className="game-item item1">
                <img src={item} alt="" />
              </div>
            ))}
          </div> */}

          {/* <div className="bscs-gamefi">EXCHANGE</div>
          <div className="game-list-item">
            {listImg6.map((item: any, i: any) => (
              <div className="game-item item1">
                <img src={item} alt="" />
              </div>
            ))}
          </div> */}
          {/* <div className="game-list-item">
            {listImg7.map((item: any, i: any) => (
              <div className="game-item item1">
                <img src={item} alt="" />
              </div>
            ))}
          </div> */}

          {/* <div className="bscs-gamefi">Media</div>
          <div className="game-list-item">
            {listImg8.map((item: any, i: any) => (
              <div className="game-item item1">
                <img src={item} alt="" />
              </div>
            ))}
          </div>

          <div className="bscs-gamefi">Security</div>
          <div className="game-list-item">
            {listImg9.map((item: any, i: any) => (
              <div className="game-item item1">
                <img src={item} alt="" />
              </div>
            ))}
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Partners;
